import { EntitySelectorPool, type EntitySelectorPoolProps } from "@salestrak/ui";
import { ISSUE_TYPE_POOL_ID } from "./hooks/use-issue-type-pool";
import { useManageTypesLabelAction } from "./hooks/use-manage-types-label-action";

export type IssueTypePoolProps = Omit<EntitySelectorPoolProps, "value" | "labelAction"> & {
  /** The pool id, when the host registered the types under its own. */
  value?: string;
};

/**
 * The project-type pool as every type picker renders it: the rows under
 * their "Project Types" label, and on that label the door to the Types
 * settings page — see {@link useManageTypesLabelAction}.
 */
export function IssueTypePool({ value = ISSUE_TYPE_POOL_ID, ...props }: IssueTypePoolProps) {
  const labelAction = useManageTypesLabelAction("/settings/issue-types");
  return <EntitySelectorPool {...props} value={value} labelAction={labelAction} />;
}
